import $ from "cash-dom"

export default {
  getHash: () => (new URL(window.location)).hash.slice(1),

  setHash: (param) => (window.location.hash = param),

  getQueryParams: () => {
    const entries = (new URL(window.location)).searchParams.entries()
    return Object.fromEntries(entries)
  },

  back: () => window.history.back(),

  redirect: (url) => window.location.replace(url),

  isSameDomain: (url) => {
    const hostName = (new URL(url, window.location)).hostname
    if (!hostName) return true
    return hostName === window.location.hostname
  },

  getHashAsElement: () => {
    if (!window.location.hash) return null
    try {
      // we wrap this in a try/catch block because window.location.hash
      // can be changed by the user
      return $(window.location.hash)
    } catch {
      return null
    }
  }
}
